const PaginationFunc = <T>(array: T[], selectedNum: number): T[] => {
  const pagiNationArray = array.slice(selectedNum * 10, selectedNum * 10 + 10);

  return pagiNationArray;
};

export default PaginationFunc;
